// components
import Header from 'components/Header'
import Footer from 'components/Footer'
import WelcomeScreen from 'components/Landing/WelcomeScreen'
import CarouselScreen from 'components/Landing/CarouselScreen'
import FeatureScreen from 'components/Landing/FeatureScreen'
import FaqScreen from 'components/Landing/FaqScreen'
import RegisterScreen from 'components/Landing/RegisterScreen'
import Container from 'components/Landing/Container'
import SetMetaInfo from 'components/_utils/SetMetaInfo'

export default function Landing() {

  return (
    <main>

      <SetMetaInfo />

      <Header />
      <WelcomeScreen />
      <Container>
        <CarouselScreen />
        <FeatureScreen />
        <FaqScreen />
        <RegisterScreen />
      </Container>
      <Footer />
    </main>
  );
}